import React from 'react';
import { IIconProps } from '../interfaces';
const WindowsIcon = (props: IIconProps) => {
  /*w14 h14*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.474 7.11v6.364L6.13 12.462V7.109h7.344zm-7.952 0v5.27L0 11.62V7.11h5.522zm0-6.017V6.43H0V1.854l5.522-.76zM13.474 0v6.43H6.13V1.011L13.474 0z" fill={props.color} fillRule="nonzero"/>
      </svg>
  )
};

export default WindowsIcon;